import apiCall from '../../../../utils/api';
import {DashboardData, SurveySlug} from './types';

// Every 2025 indicator is "non calcolabile" on a zero denominator, so the flag is dashboard-wide.
export const serializeSlug = (slug: SurveySlug) => ({
    key: slug.key,
    numerator: slug.numerator,
    ...(slug.denominator && {denominator: slug.denominator}),
    ...(slug.operation && {operation: slug.operation}),
    ...(slug.filter && {filter: slug.filter}),
    ...(slug.fallbacks?.length && {fallbacks: slug.fallbacks}),
    ...(slug.perUoa && {per_uoa: 1}),
    ...(slug.perUoaLatest && {per_uoa_latest: 1}),
    ...(slug.aggregateChildren && {per_parent_uoa: 1, self_is_parent: 1}),
    ...(slug.positiveRatio && {positive_ratio: 1}),
    null_when_uncalculable: 1,
});

// The backend echoes each slug's key; a missing key means non calcolabile, never zero.
export const fetchSlugs = async (
    container: string,
    uoaId: string,
    slugs: SurveySlug[],
): Promise<DashboardData> => {
    const res = await apiCall({
        url: `containers/${container}/uoa/${uoaId}/dashboards/fsv`,
        method: 'POST',
        data: {question_slugs: slugs.map(serializeSlug)},
    });

    const result: DashboardData = {};

    for (const slug of slugs) {
        result[slug.key] = res.data[slug.key] ?? {uoa: null, average: null};
    }

    return result;
};
